module.exports = __webpack_public_path__ + "img/logo-icon-white.94af8db2.png";